
<h3 class="title-form">*RÉGIMEN DE PEQUEÑO CONTRIBUYENTE</h3>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Ingresos por venta de bienes y/o prestación de servicios:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.smallSales)" style="text-align:right;">
			{{form.smallSales | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		(-) Valor de constancias de retención del IVA recibidas en el período a declarar:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.withholdings)" style="text-align:right;">
			{{form.withholdings | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>